import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// --- CSS --- //
import "../styles/forgot-password.css";

// --- Assets --- //
import logo from "../assets/vert-cert-logo.png";
import LoginIcon from '@mui/icons-material/Login';
import HomeIcon from '@mui/icons-material/Home';

// --- FIREBASE --- //
import { resetPassword } from "../utilities/auth/authUtils";
import { showMessageWithDelay } from "../utilities/alertUtils";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const onForgotPasswordSubmit = async (e) => {
        e.preventDefault();

        try {
          await resetPassword(email);
          await showMessageWithDelay("Password Reset Link Sent", "Check your email for a link to reset your password. It may take a few minutes to receive the email. Redirecting back to login...", "success", 5000);
          setTimeout(() => navigate("/login"), 5000); // Redirect after 5 seconds
          setError(""); // Clear any previous error
        } catch (err) {
          setError("Failed to send password reset email. Please try again.");
        }
    };

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-window">
                <a href="/login" className="login-link"><LoginIcon /></a>
                <a href="/" className="home-link"><HomeIcon /></a>
                <a href="/"><img src={logo} alt="Vert Cert Logo" className="logo" /></a>
                <h2 className="login-title">Forgot Password</h2>
                <form onSubmit={onForgotPasswordSubmit}>
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button type="submit">Send Reset Link</button>
                </form>
                {error && <p className="error-message">{error}</p>}
                <div className="sign-up-link-container">
                    <p>Dont have an account?</p>
                    <a href="/sign-up">Sign Up</a>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;